import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ModalsRejectComponent } from './modals-reject/modals-reject.component';
import { ModalsAcceptComponent } from './modals-accept/modals-accept.component';
import { ModalsScaleComponent } from './modals-scale/modals-scale.component';
import {ModalsObservationComponent}  from '../policy-list/modals-observation/modals-observation.component'
import {PolicyApproversListService} from '../service/policy-approvers-list.service';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import { NgxSpinnerService } from 'ngx-spinner';
import { PolicyListService } from '../service/policy-list.service';
import { ModErrorComponent } from '../modals/mod-error/mod-error.component';

@Component({
  selector: 'app-policy-approver',
  templateUrl: './policy-approver.component.html',
  styleUrls: ['./policy-approver.component.css']
})
export class PolicyApproverComponent implements OnInit {
  @ViewChild('paginator') paginator: MatPaginator;
  pageSizeOptions: any [] = [5, 10, 20];
  pageSize = 10;
  pageNumber = 1;
  user = 1;
  totalPage: any [] = [];
  SeeApprovers: any[] = [];
  totalItems: number;

    
  typesSelect: any;
  statusSelect: any;
  isPolicyRegionalApprover = false;
  
  //---------preFilter
  searchPeopleRequestor:string;
  peoples=  [];
  searchPeople :string;
  personFound = false;
  personNotFound = false;
  
  searchPeopleModifiedby:string;
  peoplesModified=  [];
  searchPeopleModif :string;
  personFoundModif = false;
  personNotFoundModif = false;



  //-----------Filters
  requestF: string;
  typeF: string;
  statusF: string;
  order: string;
  baseReq: string;
  requesterIdF: string;
  modifiedIdF: string;
  //-----------------asc&desc state---------------------
  requestDesc = false;
  statusDesc = false;

  constructor(public dialog: MatDialog, private dataApi: PolicyApproversListService,   private spinner: NgxSpinnerService,
              private _snackBar: MatSnackBar,private dataApiob: PolicyListService) { 
    this.requestF = '';
    this.typeF = '';
    this.statusF = '';
    this.order = "&order_by=requestNumber&desc=true";
    this.baseReq = this.order;
  }

  getPolicyApproversList() {
    this.spinner.show("loading");
    this.dataApi.getPolicyApproversList(this.pageNumber, this.pageSize, this.baseReq)
      .subscribe((data: any) => {
        this.SeeApprovers = data.items;
        this.typesSelect= data.types;
        this.statusSelect= data.statuses;
        this.pageNumber = data.paginator.page;
        this.pageSize = data.paginator.limit;
        this.totalPage = data.paginator.totalPages;
        this.totalItems = data.paginator.totalItems;
        this.isPolicyRegionalApprover = Boolean(data.isPolicyRegionalApprover);
        this.spinner.hide("loading");
      },(err) => {
        this.spinner.hide("loading");
        if(err.error.error !== 'Invalid token.') {
          this.dialog.open(ModErrorComponent, {
            width: 'auto',
            panelClass: 'myapp-no-padding-dialog',
          });
        }
      });
  }

  openDialogAccept(dataReq: any) {
    this.dialog.open(ModalsAcceptComponent, {panelClass: 'myapp-no-padding-dialog', data: {
      sendData: dataReq }}
    ).afterClosed().subscribe((policy) => {

      if(policy === undefined || policy === null || policy === '') {
        return;
      }
      this.spinner.show("loading");
      this.dataApi.updatePolicyApprover(policy).subscribe(
        () => {
          // this._snackBar.open('Done... Updating table', '', {
          //   duration: 3000,
          // });
          this.getPolicyApproversList();
        },
        (err) => {
          this.spinner.hide("loading");
          if(err.error.error !== 'Invalid token.') {
            this.dialog.open(ModErrorComponent, {
              width: 'auto',
              panelClass: 'myapp-no-padding-dialog',
            });
          }
        }
      );
    });
  }

  generateReport(){
    this.dataApi.generateReport();
  }

  openDialogReject(dataReq: any)  {
    this.dialog.open(ModalsRejectComponent, {panelClass: 'myapp-no-padding-dialog', data: {
      sendData: dataReq  }}
    ).afterClosed().subscribe((policy) => {
      if(policy === undefined || policy === null || policy === '') {
        return;
      }
      this.spinner.show("loading");
      this.dataApi.updatePolicyApprover(policy).subscribe(
        () => {
          // this._snackBar.open('Done... Updating table', '', {
          //   duration: 3000,
          // });
          this.getPolicyApproversList();
        },
        (err) => {
          this.spinner.hide("loading");
          if(err.error.error !== 'Invalid token.') {
            this.dialog.open(ModErrorComponent, {
              width: 'auto',
              panelClass: 'myapp-no-padding-dialog',
            });
          }
        }
      );
    });
  }

  openDialogScale(dataReq: any) {
    this.dialog.open(ModalsScaleComponent, {panelClass: 'myapp-no-padding-dialog', data: {
      sendData: dataReq }}
    ).afterClosed().subscribe((policy) => {
      if(policy === undefined || policy === null || policy === '') {
        return;
      }
      this.spinner.show("loading");
      this.dataApi.updatePolicyApprover(policy).subscribe(
        () => {
          // this._snackBar.open('Done... Updating table', '', {
          //   duration: 3000,
          // });
          this.getPolicyApproversList();
        },
        (err) => {
          this.spinner.hide("loading");
          if(err.error.error !== 'Invalid token.') {
            this.dialog.open(ModErrorComponent, {
              width: 'auto',
              panelClass: 'myapp-no-padding-dialog',
            });
          }
        }
      );
    });
  }
  openDialogObs(dataReq) {
    this.spinner.show("loading");
    this.dataApiob.getObservacion(dataReq.policyId).subscribe((data: any) => {
      let observations;
      if (data){
        observations = data;
      } else {
        observations = [];
      }
      this.spinner.hide("loading");
      this.dialog.open(ModalsObservationComponent, {panelClass: 'myapp-no-padding-dialog', data: observations });
    }, (err) => {
      this.spinner.hide("loading");
      if(err.error.error !== 'Invalid token.') {
        this.dialog.open(ModErrorComponent, {
          width: 'auto',
          panelClass: 'myapp-no-padding-dialog',
        });
      }
    });
  }

  ngOnInit() {
    this.getPolicyApproversList();
  }

  handlePage(e: PageEvent) {

    this.pageSize = e.pageSize;
    this.pageNumber = e.pageIndex + 1;
    this.getPolicyApproversList();
  }


  //------ method set filters ---
  orderby(nameColumn, typeAsc){
    switch(nameColumn){
      case 'requestNumber': {
        this.requestDesc = !this.requestDesc;
        this.statusDesc = false;
        break;
      }
      case 'status':{
        this.requestDesc = false;
        this.statusDesc = !this.statusDesc;
        break;
      }
    }
    const param = `&order_by=${nameColumn}&desc=${typeAsc}`; 
    this.order = param;
    this.getallpolicyFilter();
  }
  requestFilter(){
    if(this.requestF === '' || this.requestF === null || this.requestF === undefined ){
      return '';
    } else {
      return '&policyId='+ this.requestF;
    };
  }
  TypeFilter(){
    if(this.typeF === '' || this.typeF ===null || this.typeF === undefined ){
      return '';
    } else {
      return '&type='+ this.typeF;
    };
  }
  StatusFilter(){
    if(this.statusF === '' || this.statusF === null || this.statusF === undefined){
      return '';
    } else {
      return '&status=' + this.statusF;
    };
  }

  requestorFilter(){
    if(this.requesterIdF === '' || this.requesterIdF === null || this.requesterIdF === undefined){
      return '';
    } else {
      return '&requestorId=' + this.requesterIdF;
    };
  }

  modifiedByFilter(){
    if(this.modifiedIdF === '' || this.modifiedIdF === null || this.modifiedIdF === undefined){
      return '';
    } else {
      return '&modifiedById=' + this.modifiedIdF;
    };
  }
  getallpolicyFilter() {
    this.baseReq=this.order + this.TypeFilter() + this.StatusFilter() + this.requestFilter() 
    + this.requestorFilter() + this.modifiedByFilter();
    this.applyFilter(this.baseReq);
  }

  applyFilter(filterUrl){
    this.spinner.show("loading");
    this.paginator.firstPage();
    this.dataApi.getPolicyApproversList(this.pageNumber, this.pageSize, filterUrl)
      .subscribe((data: any) => {
        this.SeeApprovers = data.items;
        this.typesSelect = data.types;
        this.statusSelect = data.statuses;
        this.pageNumber = data.paginator.page;
        this.pageSize = data.paginator.limit;
        this.totalPage = data.paginator.totalPages;
        this.totalItems = data.paginator.totalItems;
        this.spinner.hide("loading");

      },(err) => {
        this.spinner.hide("loading");
        if(err.error.error !== 'Invalid token.') {
          this.dialog.open(ModErrorComponent, {
            width: 'auto',
            panelClass: 'myapp-no-padding-dialog',
          });
        }
      });
  }


  searchPerson(event: Event){ // search person by letter
    this.personFound =true;

    const nameSearch = (event.target as HTMLInputElement).value;
    if(nameSearch!= ''){
      this.dataApi.getPeropleSearchByletter(nameSearch).subscribe(
        (data: any)=>{
          if(data==null || data==undefined){
            this.peoples= [];
          }else{
            this.peoples=  data;
          }
        },
        (err: any)=>{
          this.peoples= [];
        }
      );
    }else{
      this.peoples= [];
    }
  }

  searchPersonModified(event: Event){ // search person by letter
    this.personFoundModif =true;

    const nameSearch = (event.target as HTMLInputElement).value;
    if(nameSearch!= ''){
      this.dataApi.getPeropleSearchByletter(nameSearch).subscribe(
        (data: any)=>{
          if(data==null || data==undefined){
            this.peoplesModified= [];
          }else{
            this.peoplesModified=  data;
          }
        },
        (err: any)=>{
          this.peoplesModified= [];
        }
      );
    }else{
      this.peoplesModified= [];
    }
  }
  addpeopleMdmidFilterValue(option){
  
    this.requesterIdF= option;
    this.getallpolicyFilter()

  }
  addpeopleMdmidModifiedFilterValue(option){
  
    this.modifiedIdF= option;
    this.getallpolicyFilter()

  }

  clearFilter(){
    this.searchPeopleRequestor= '';
    this.searchPeopleModifiedby= '';
    this.requesterIdF='';
    this.modifiedIdF='';
    this.peoples= []
    this.peoplesModified= []



    this.requestF = '';
    this.typeF = '';
    this.statusF = '';
    this.order = "&order_by=requestNumber&desc=true";
    this.getallpolicyFilter();
  }
  isNegative(requestF:string){
    let evaluate=Number(requestF)
    if(evaluate<0) {
      return true
    }
    else {
      return false;
    }  

  }
 

}
